export const MIDDLEWARE = {
  PAGE_SEO: 'page-seo',
  ASYNC_MIDDLEWARES: 'async-middlewares',
  CONFIRM_ROUTE_CHANGE: 'confirm-route-change'
}
